import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { CatIconEmail } from 'blocks-nextjs/blocks-react/components/Icons/Email';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { CatIconPhone } from 'blocks-nextjs/blocks-react/components/Icons/Phone';
import { useTranslations } from 'next-intl';
import styles from './NotificationContactDealerBody.module.scss';
import NotificationCardHeader from '../notification-card-header/notification-card-header';

export const NotificationContactDealerBody = ({
  handleClickClose,
  storeAddress,
  notification
}) => {
  const { phone, email } = storeAddress;
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const t = useTranslations();
  const formattedPhone = phone.replace(/\D/g, '.');

  return (
    <>
      <NotificationCardHeader notification={notification} />
      <div className="pt-3">
        <CatButton
          variant="primary"
          href={`mailto:${email}`}
          data-testid="email-us-button"
          fullWidth={!isMD}
          onClick={handleClickClose}
          className="pb-3 pe-0 pb-md-0 pe-md-3"
        >
          <CatIconEmail slot="before" /> {t('EMAIL_US')}
        </CatButton>
        <CatButton
          href={`tel:${phone}`}
          data-testid="call-us-button"
          fullWidth={!isMD}
          onClick={handleClickClose}
        >
          <CatIconPhone slot="before" aria-label={phone} />
          {phone ? formattedPhone : <div className={styles['phone-btn']} />}
        </CatButton>
      </div>
    </>
  );
};
